import { usePersistenceStore } from '@/stores/persistence';
import styles from './AutosaveBanner.module.css';

function formatTime(ts: number | null): string | null {
  if (!ts) return null;
  try {
    return new Date(ts).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  } catch {
    return null;
  }
}

/** Dauerhafter Hinweis, solange der letzte Autosave nach IndexedDB
 *  fehlgeschlagen ist (QuotaExceededError, DataCloneError …). Verschwindet
 *  von selbst, sobald ein Save gelingt (Audit M8e). Mounted in AppShell,
 *  also auf Generation und Summary sichtbar. */
export function AutosaveBanner() {
  const error = usePersistenceStore((s) => s.autosaveError);
  const lastSavedAt = usePersistenceStore((s) => s.lastSavedAt);
  const retry = usePersistenceStore((s) => s.retry);
  if (!error) return null;
  const since = formatTime(lastSavedAt);
  return (
    <div className={styles.banner} role="alert">
      <i className={`ph-fill ph-warning ${styles.icon}`} aria-hidden="true" />
      <div className={styles.text}>
        <strong>Autosave failed</strong> — your work is still on screen, but a
        reload could lose {since ? `changes made since ${since}` : 'unsaved changes'}.
        Upload your finished assets soon.
        <span className={styles.detail}>{error}</span>
      </div>
      {retry && (
        <button type="button" className={styles.retry} onClick={() => retry()}>
          <i className="ph-bold ph-arrow-clockwise" aria-hidden="true" />
          Retry
        </button>
      )}
    </div>
  );
}
